import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import Home from './Home';
import BookingFlow from './BookingFlow';
import MyBookings from './MyBookings';
import Profile from './Profile';

function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/app', icon: 'Home', label: 'Home' },
    { path: '/app/bookings', icon: 'List', label: 'Bookings' },
    { path: '/app/profile', icon: 'User', label: 'Profile' }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 pb-safe pt-2 px-6 flex justify-between items-center z-50 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
      {navItems.map((item) => {
        const isActive = location.pathname === item.path || (item.path !== '/app' && location.pathname.startsWith(item.path));
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center p-2 min-w-[64px] transition-colors ${isActive ? 'text-brand-navy' : 'text-gray-400'}`}
          >
            <SafeIcon name={item.icon} className={`text-2xl mb-1 ${isActive ? 'text-brand-gold' : ''}`} />
            <span className="text-[10px] font-medium">{item.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default function CustomerApp() {
  return (
    <div className="min-h-screen bg-brand-light pb-20">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/book" element={<BookingFlow />} />
        <Route path="/bookings" element={<MyBookings />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>
      <BottomNav />
    </div>
  );
}